import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import InscriptionDroitImage from "../../components/InscriptionPage/InscriptionDroitImage/InscriptionDroitImage";
import InscriptionInfoPersonnelles from "../../components/InscriptionPage/InscriptionInfoPersonnelles/InscriptionInfoPersonnelles";

import Button from "../../components/global/Button/Button";
import { Direction } from "../../schemas/collaborateur/collaborateur.schema";
import {
  CollaborateurFormSchema,
  CollaborateurFormSchemaType,
} from "../../schemas/collaborateur/collaborateurForm.schema";
import { useCollaborteurStore } from "../../stores/collaborateur/collaborateur.store";
import { useEtablissementStore } from "../../stores/etablissement/etablissement.store";

import { useMsal } from "@azure/msal-react";
import BreadCrumbNavbar from "../../components/BreadCrumbNavbar/BreadCrumbNavbar";
import { Etablissement } from "../../schemas/etablissement/etablissemen.schema";
import { formatDate, getUserEmail } from "../../utils";
import styles from "./InscriptionPage.module.scss";

export default function InscriptionPage() {
  const { t } = useTranslation();

  //* react-router-dom
  const navigate = useNavigate();
  const { selectedEtablissement, selectedParticipation } =
    useEtablissementStore();
  const { setSeletecCollaborateur } = useCollaborteurStore();

  const { control, handleSubmit } = useForm<CollaborateurFormSchemaType>({
    resolver: yupResolver(CollaborateurFormSchema(t)),
  });

  const { accounts } = useMsal();
  const { userEmail } = getUserEmail(accounts);

  function onSubmit(data: CollaborateurFormSchemaType) {
    setSeletecCollaborateur({
      nom: data?.nom as string,
      prenom: data?.prenom as string,
      email: data?.email as string,
      phone: data?.phone as string,
      hasDroitImage: data?.hasDroitImage as boolean,
      civilite: data?.civilite as string,
      fonction: data?.fonction as string,
      direction: data?.direction as Direction,
      participation: selectedParticipation,
      userEmail: userEmail,
      etablissement: selectedEtablissement as Etablissement,
    });
    navigate("recapitulatif");
  }

  // Format la date pour l'affichage et la traduction
  const formattedDate = formatDate(selectedParticipation?.dateParticipation as Date, {
    hasFullWeekDay: true, hasDayName: true
  });

  return (
    <article className={styles.inscriptionPage}>
      <BreadCrumbNavbar step="inscription" returnTo="/recherche" />
      <header className={styles.inscriptionPage__header}>
        <h1>{t("titles.registration")}</h1>
        <section className={styles.inscriptionPage__header__text}>
          <p>
            {t("inscriptionPage.dayConfirmation", {
              jobTitle: selectedParticipation?.metierTitle,
              establishmentName: selectedParticipation?.etablissementName,
              date: formatDate(selectedParticipation?.dateParticipation as Date, {
                hasFullWeekDay: true,
                hasDayName: true
              })
            })}
          </p>
          <p>
            <strong>{t("inscriptionPage.warning")}</strong>
            {t("inscriptionPage.travelExpenses")}
          </p>
          <p>{t("inscriptionPage.requiredFields")}</p>
        </section>
      </header>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={styles.inscriptionPage__main}
      >
        <InscriptionInfoPersonnelles<CollaborateurFormSchemaType>
          control={control}
        />
        <InscriptionDroitImage<CollaborateurFormSchemaType>
          control={control}
          checkboxInputName="hasDroitImage"
        />
        <Button
          type="submit"
          text={t('buttons.validate')}
          buttonBackGroundColor="linear-blue"
          textColor="white"
        />
      </form>
      <footer className={styles.inscriptionPage__footer}></footer>
    </article>
  );
}
